import type { Nullish } from '@iheartjane/types';
import { useFormContext, useWatch } from 'react-hook-form';

import { useCheckout } from '@jane/shared-ecomm/providers';
import { phoneDigits } from '@jane/shared/util';

const phoneChanged = (
  formPhone: Nullish<string>,
  storedPhone: Nullish<string>
) => {
  // Untouched watches as undefined, cleared as empty: no number offered, none new.
  if (!`${formPhone ?? ''}`.trim()) return false;

  const formDigits = phoneDigits(formPhone);
  const storedDigits = phoneDigits(storedPhone);

  // plain_phone only strips a leading "+1", so the strings differ on separators alone.
  if (formDigits && storedDigits) return formDigits !== storedDigits;

  // Unparseable: keep the raw comparison, erring toward verifying.
  return formPhone !== storedPhone;
};

export const useHasNewPhone = () => {
  const { control } = useFormContext();
  const phone = useWatch({
    control,
    name: 'customerInformation.phone',
  });
  const {
    customer: { authenticated, phone: originalPhone },
  } = useCheckout();

  return {
    hasNewPhone: Boolean(authenticated && phoneChanged(phone, originalPhone)),
    newPhone: phone,
  };
};
